import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const WorkspaceSettingsAccessTokensLoadable = Loadable({
  loading: LoadingPage,
  loader: () => import('./access-tokens'),
});
